import type {
  GetCartProductsItem,
  GetCartProductsResponse,
} from "~/types/cart";
import errorSent from "~/utils/errors/errorSent";

import { clientApiCall } from "./apiCallWrapper";

const withCredentials = { withCredentials: true };

// Запросы оформления заказа помечены critical: без корзины и расчёта доставки
// заказ не оформить, поэтому о любом их сбое (403, таймаут, обрыв) сообщаем.

/** Клиентский API корзины и оформления заказа Bitrix bxApi (/cart/*). */
export default (_axios: any, config: any) => ({
  getEdostData(cityName: string, regionName = "", kladrId = "") {
    return clientApiCall(`${config.API_URL}/cart/getEdostData`, {
      api: "cart.getEdostData",
      critical: true,
      method: "post",
      params: {},
      axiosConfig: {
        ...withCredentials,
        params: {
          city_name_new: cityName,
          region_name: regionName,
          kladr_id: kladrId,
        },
      },
    });
  },

  /**
   * PRODUCT_DATA товаров корзины одним запросом (данные для отрисовки +
   * фолбэк картинок). Заменяет пару Api.server.getCartProducts +
   * ApiClient.product.getProductPhotoIds. Ответ — массив в порядке items.
   */
  getCartProducts(
    items: GetCartProductsItem[],
    reset = false,
  ): Promise<GetCartProductsResponse | null> {
    return clientApiCall<GetCartProductsResponse>(
      `${config.API_SERVER_URL}/client/cart/getCartProducts`,
      {
        api: "cart.getCartProducts",
        critical: true,
        method: "post",
        params: { items, reset },
        skipForRobots: true,
      },
    );
  },

  getCartDeliveryTk(productIds: (number | string)[], time = "", weekday = "") {
    return clientApiCall(
      `${config.API_SERVER_URL}/client/cart/getCartDeliveryTk`,
      {
        api: "cart.getCartDeliveryTk",
        critical: true,
        params: {
          productIds: productIds.join(","),
          time,
          weekday,
        },
      },
    );
  },

  /** Оформление заказа. Критичный вызов: об ошибках сообщаем всегда. */
  async initOrder(params: Record<string, unknown>) {
    const data: any = await clientApiCall(`${config.API_URL}/cart/initOrder`, {
      api: "cart.initOrder",
      critical: true,
      lead: true,
      method: "post",
      params: {},
      // Заказ уходит в query (axiosConfig.params) — кладём его в событие, чтобы восстановить
      extra: { orderParams: params },
      axiosConfig: {
        ...withCredentials,
        // Как у formsV2.sentForm: после сохранения заказа Битрикс синхронно
        // шлёт его во внешние сервисы, 20 с на это не всегда хватает.
        timeout: 60000,
        params,
      },
    });
    // Ответ есть, а заказа нет: «Заполните все обязательные поля», «Не корректный
    // номер телефона» или ошибка сохранения (Битрикс кладёт её в ERROR, не в message).
    // Пустой ответ и null разбирает useCartOrderLogic (orderInitFailed).
    if (data && !data.ORDER_ID) {
      errorSent("cartError", "orderRejected", {
        message: data.message || data.ERROR || null,
      });
    }
    return data;
  },
});
